import { useState } from 'react'
import styled from 'styled-components'
import { Row, Col } from 'antd'
import BaseButton from 'widgets/BaseButton'

const WrapperCookie = styled.div`
  position: fixed;
  z-index:1002 !important;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0%);
  width: 100vw;
  padding: 12px 20px;
  z-index: 999;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(5px);
  border-radius: 15px 15px 0px 0px;
  transition: 0.25s;

  &.hidden {
    transform: translate(-50%, 100%);
  }

  ${({ theme }) => theme.mediaQueries.md} {
    padding: 12px 40px;
  }

  .cookie-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    row-gap: 15px;
    text-align: center;

    ${({ theme }) => theme.mediaQueries.md} {
      flex-direction: row;
      text-align: left;
    }

    .cookie-text {
      flex: 1;
      max-width: 800px;
      margin-right: 15px;

      h3 {
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 30px;
        color: #006dfe;
        margin-bottom: 4px;
      }

      p {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        color: #6d6d6d;
      }
    }

    .cookie-action {
      [type='button'] {
        min-width: 180px;

        &:hover {
          background: linear-gradient(143.11deg, #006dfe 21.44%, #43e8e1 126.28%);
        }
      }
    }
  }
`

interface Props {
  setAcceptCookie?: (input: boolean) => void
  setCheckCookie?: (input: boolean) => void
  checkCookie?: boolean
}

const Cookie: React.FC<Props> = ({ setAcceptCookie, setCheckCookie, checkCookie }) => {
  const handleAcceptCookie = () => {
    setAcceptCookie(true)
    setCheckCookie(true)
  }

  return (
    <WrapperCookie className={`${checkCookie ? 'hidden' : ''}`}>
      <div className="container">
        <div className="cookie-content">
          <div className="cookie-text">
            <h3>Cookie Consent</h3>
            <p>
              We use cookies to make your interactions with our website more meaningful. They help us better understand
              how our websites are used, so we can tailor content for you. For more information about the different
              cookies we are using, read the Privacy Policy.
            </p>
          </div>
          <div className="cookie-action">
            <BaseButton background="#006DFE" borderRadius="30px" onClick={() => handleAcceptCookie()}>
              I understand
            </BaseButton>
          </div>
        </div>
      </div>
    </WrapperCookie>
  )
}

export default Cookie
